import React from 'react';
import AppTimelineWrapper from '@components/app-session-timeline/Wrapper';
import { useSelector } from 'react-redux';
import localStorage from '@utils/localStorage';
import createKeyByUserName from '@utils/tempDashboard/createKeyByUserName';
import * as types from '@store/tempDashboard/types';
import { selectedCustomerIdSelector, selectedUserNameSelector } from '@store/common/selectors';
import AppTimelinePageStyled from './styled';
import { useHistory } from 'react-router-dom';
import sankeyStore from '@src/globalStore/sankeyStore';

const useGetLocalStorageKey = () => {
  const customerId = useSelector(selectedCustomerIdSelector);
  const userName = useSelector(selectedUserNameSelector);
  return createKeyByUserName(types.prefix, customerId, userName);
};
interface AppTimelineProps {
  match: {
    params: { viewerId: any; id: string };
  };
  location: {
    search: string;
  };
}

const AppTimelinePage = ({ match, location }: AppTimelineProps) => {
  const {
    params: { viewerId, id },
  } = match;
  const { search } = location;
  const queryParams = new URLSearchParams(search);
  let clientId = queryParams.get('clientId');
  const userId = queryParams.get('userId');
  const history = useHistory();
  let resViewerId = viewerId;
  if (userId) {
    resViewerId = userId;
  }
  const localStorageKey = useGetLocalStorageKey();
  const clientIdForTempDashbords = sankeyStore((state) => state.clientIdForTempDashbords);
  // get the values by local storage key
  const localStorageTempDashboards = localStorage.get(localStorageKey);
  const curDashbord = localStorageTempDashboards?.dashboards[id];
  const { interval, source } = curDashbord?.dashboard || {};
  if (source === 'emp' && !clientId) {
    // get clientId by id from clientIdForTempDashbords
    clientId = clientIdForTempDashbords[id];
    history.push({ search: `clientId=${clientId}` });
  }

  return (
    <AppTimelineDetail
      viewerId={resViewerId ?? ''}
      id={id}
      clientId={clientId ?? ''}
      interval={interval}
    />
  );
};

const AppTimelineDetail = ({ id, viewerId, clientId, interval }) => {
  return (
    <AppTimelinePageStyled>
      <AppTimelineWrapper id={id} viewerId={viewerId} clientId={clientId} interval={interval} />
    </AppTimelinePageStyled>
  );
};

export default AppTimelinePage;
